export const razorid = {
    "kyidlive" : "rzp_live_kuUVYOuSOKCEhO",
    "kyidtest" : "rzp_test_64UdZkdfj3H9s5"
}